@if (!isJanusUI()){
<app-navbar (pixelHeightChanged)="setTopMarginForNavbar($event)"></app-navbar>
}

@if (isJanusUI()) {
<div style="display: flex;justify-content: center;align-items: center;" *ngIf="!application">
  <mat-progress-spinner mode="indeterminate" diameter="48">
  </mat-progress-spinner>
</div>
}@else{
<div style="padding-top: 100px" *ngIf="!application">
  <app-loader></app-loader>
</div>
}
<div #printSection *ngIf="application"
  [ngClass]="{'janus-summary-main-content':isJanusUI() &&context.janusLayout ==='applicant' }">
  <div class="arrow-content">
    <wm-common-icon [data]="{iconName:arrowLeftIcon}" (click)="backClickOfSummary()" class="arrow-icon"></wm-common-icon>
  </div>
  <div class="close-btn-size" [ngClass]="{'janus-header':isJanusUI()  && context.janusLayout==='applicant'}">
    @if (context.janusLayout==='applicant') {
    <wm-common-text class="permit-header" [data]="{text:application?.name}"></wm-common-text>
    <wm-common-icon class="close-btn" [data]="{iconName:closeIcon}" (click)="closeSummary()"></wm-common-icon>
    }


  </div>
  <app-application-summary-info *ngIf="isJanusUI() && context.janusLayout==='applicant'"
    [applicationNumber]="application?.combinedApplicationNumber" [userName]="submitter?.userName"
    [startedOn]="application?.startedOn" [status]="application?.applicantStatus"></app-application-summary-info>

  <div class="summary-content"
  [ngClass]="{
    'janus-summary-content':isJanusUI(),
    'bg-white': bgWhite === true
    }"
    [style.margin-top.px]="!isJanusUI() ? topMargin : null"   *ngIf="application">
    @if (!isJanusUI()){
    <div class="application-header">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-4">
                <span>{{ application.name }}</span>
                <h6>{{ application.combinedApplicationNumber }}</h6>
              </div>
              <div class="col-sm-4">
                <span>Amount Paid</span>
                <h6>{{ totalPaid | currency }}</h6>
              </div>
              <div class="col-sm-4 align">
                <div ngbDropdown class="d-inline-block" *ngIf="!printMode">
                  <button class="btn btn-raised btn-secondary" id="dropdownBasic1" ngbDropdownToggle>
                    Actions
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <a *ngFor="let pr of paymentRequests; let i = index" ngbDropdownItem
                      [href]="apiBase + '/files/receipt/' + pr.id" target="_blank" rel="noopener">
                      View receipt
                      <span *ngIf="paymentRequests.length > 1">#{{ i + 1 }}</span>
                    </a>
                    <a *ngIf="canUnVoid()" ngbDropdownItem (click)="unVoid()">
                      Unvoid
                    </a>
                    <a *ngIf="showReopenClosedApplicationButton && canReopenClosedApplication" ngbDropdownItem
                      (click)="undoCloseApplication()">
                      Reopen
                    </a>
                    <a *ngIf="isChildApplication" ngbDropdownItem (click)="returnToParent()">
                      Return to Parent
                    </a>
                    <a ngbDropdownItem [routerLink]="[
                      '/application/workflow-application-print-summary',
                      applicationId
                    ]" target="_blank">Printer Friendly</a>
                    <a *ngIf="
                      registrationId &&
                      applicationStatus === ApplicationStatus.Completed &&
                      applicationWorkflowType === WorkflowType.Renewable
                    " ngbDropdownItem (click)="startRenewalApplication()">
                      Renew
                    </a>
                    <a ngbDropdownItem (click)="openApplicationWorkflowBuilder()" *ngIf="canViewVersion">
                      View Application Workflow
                    </a>
                    <a ngbDropdownItem (click)="recalculateApplicationDescription()"
                      *ngIf="canEditCompletedApplication">
                      Recalculate Application Description
                    </a>
                    <a *ngIf="showUnDiscardButton && canEditCompletedApplication" ngbDropdownItem
                      (click)="undiscardApplication()">
                      Un-Discard Application
                    </a>
                    <a ngbDropdownItem *ngIf="canEditApplicationNumber" (click)="editApplicationNumber()">
                      Edit Application Number
                      <wm-edit-application-number #editAppNumber [form]="form" [showButton]="false" (numberChanged)="
                        application.combinedApplicationNumber = $event
                      " [clientApplicationNumber]="
                        application.clientApplicationNumber
                      " [applicationId]="application.id" [applicationNumber]="
                        application.combinedApplicationNumber
                      "></wm-edit-application-number>
                    </a>
                    <a *ngIf="showReopenApplicationButton && canReopenApplication" ngbDropdownItem
                      (click)="setApplicationBackToInProgress()">
                      Reopen Application
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4" *ngIf="submitter">
                <span>Applicant</span>
                <h6>{{ submitter.name }}</h6>
              </div>
              <div class="col-sm-4">
                <span>Created</span>
                <h6>{{ application.startedOn | date: 'longDate' }}</h6>
              </div>
              <div class="col-sm-4">
                <span>Status</span>
                <h6>
                  <strong>
                    {{ application.status | applicationStatus }}
                  </strong>
                </h6>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="card">
              <div class="card-body">
                <div class="row align-items-center text-center">
                  <div class="col-3" style="border-right: 1px solid black;">
                    <span>Number</span>
                    <h6>{{ application.combinedApplicationNumber }}</h6>
                  </div>
                  <div class="col-6">
                    <span class="font-weight-bold">{{
                      application.description
                      }}</span>
                    <br />
                    <span class="text-muted">Submitted
                      <span class="text-muted" *ngIf="submitter">
                        by {{ submitter.userName }}
                      </span>
                      on {{ application.startedOn | date: 'M/d/yyyy' }}
                    </span>
                  </div>
                  <div class="col-3" style="border-left: 1px solid black;">
                    <wm-qr-code [data]="applicationUrl"></wm-qr-code>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    }@else {
    <!-- added by amisha 03-06-2026 reason: hide the existing applicant summary header on mobile when showing the compact mobile header -->
    <div class="view-application-header" [ngClass]="{'summary-desktop-header': context.janusLayout==='applicant'}">
      <div class="view-application-text">
        <div class="application-number">
          <wm-common-text [data]="{text:`Application ${application.combinedApplicationNumber}`}"></wm-common-text>
        </div>
        <!-- @if(application.status === 2){ -->
        <div class="application-status">
          <wm-common-text
            [data]="{text:`Submitted by ${submitter.userName} on ${application.startedOn}`}"></wm-common-text>
        </div>
        <!-- } -->
      </div>
      <div class="header-actions">
        <div class="print-icon-container" *ngIf="canViewVersion"
             title="View Application Workflow" (click)="openApplicationWorkflowBuilder()">
          <wm-common-icon [data]="{iconName:applicationWorkflowIcon}"></wm-common-icon>
        </div>
        @if (showPrint === true) {
          <div class="print-icon-container">
            <wm-common-icon [data]="{iconName:printIcon}" (click)="onPrint()"></wm-common-icon>
          </div>
        }
      </div>

    </div>
    <!-- added by amisha 03-06-2026 reason: render a compact applicant summary header for mobile view -->
    <div class="view-application-header summary-mobile-header" *ngIf="context.janusLayout==='applicant'">
      <div class="view-application-text">
        <div class="summary-mobile-title">
          <div class="application-number">
            <wm-common-text [data]="{text:compactHeaderApplicationText}"></wm-common-text>
          </div>
          @if (showCompactCompletedIcon) {
          <mat-icon class="summary-mobile-status-icon">check_circle</mat-icon>
          }
        </div>
        <div class="application-status">
          <wm-common-text [data]="{text:compactHeaderStatusText}"></wm-common-text>
        </div>
      </div>
      <div class="header-actions">
        <div class="print-icon-container" *ngIf="canViewVersion"
             title="View Application Workflow" (click)="openApplicationWorkflowBuilder()">
          <wm-common-icon [data]="{iconName:applicationWorkflowIcon}"></wm-common-icon>
        </div>
        <div class="print-icon-container">
          <wm-common-icon [data]="{iconName:printIcon}" (click)="onPrint()"></wm-common-icon>
        </div>
      </div>
    </div>
    }

    <div class="container">
      <div class="row mt-4">
        <div class="col" *ngIf="submitter">
          <h4>Applicant</h4>
          <p>{{ submitter.name }}</p>
          <p>
            <a [ngClass]="{'janus-anchor':isJanusUI()}" href="tel:{{ submitter.phoneNumber }}">
              {{ submitter.phoneNumber }}
            </a>
          </p>
          <p>
            <a [ngClass]="{'janus-anchor':isJanusUI()}" href="mailto:{{ submitter.emailAddress }}">{{
              submitter.emailAddress
              }}</a>
          </p>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          @if(editApplicationJanusView === true){
          <wm-application-readonly [applicationId]="application.id" [application]="application"
          [activities]="summaryActivities" [editApplicationJanusView]="true" [appStatusCode]="applicationStatus">
        </wm-application-readonly>
          }@else{
            <wm-application-readonly *ngIf="summaryActivities && !printMode" [applicationId]="application.id"
            [application]="application" [activities]="summaryActivities">
          </wm-application-readonly>
          <wm-application-print-summary *ngIf="summaryActivities && printMode" [activities]="summaryActivities"
            [applicationId]="application.id" [application]="application"></wm-application-print-summary>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- added by furkan 07-04-2026  -->
  @if (isJanusUI() && context.janusLayout === 'applicant') {

  <div class="janus-applicant-footer">
    @if (application?.status === ApplicationStatus.Completed || application?.status === ApplicationStatus.Voided) {}
    <wm-common-button class="janus-close-btn" [data]="{text: 'CLOSE'}" (click)="closeSummary()"></wm-common-button>
  </div>
  }
  <!-- ended by furkan 07-04-2026  -->

</div>

<nav class="navbar fixed-bottom navbar-expand-lg navbar-light bg-white" *ngIf="isTestApplication">
  <div class="container-fluid">
    <form class="form-inline ml-auto mr-auto">
      <button class="btn btn-raised mx-2 btn-danger" type="button" (click)="exitTestApplication()">
        Exit Test Application
      </button>
    </form>
  </div>
</nav>

<wm-modal-confirm #RecalculateDescription [showButtonText]="true" [showButton]="false" [buttonText]="'blah'"
  commandText="Yes" title="Update Application Description" (accepted)="recalculateApplicationDescription(true)"
  btnColor="danger" class="mx-2" [closeOnAccept]="false">
  Are you sure you want to recalculate the Application Description?
</wm-modal-confirm>

<wm-modal-confirm #UndiscardApplication [showButtonText]="true" [showButton]="false" [buttonText]="''" commandText="Yes"
  title="Set Application To In Progress" (accepted)="undiscardApplication(true)" btnColor="success" class="mx-2"
  [closeOnAccept]="false">
  Are you sure you want to set this application to In Progress?
</wm-modal-confirm>


<wm-modal-confirm #reopenApplication [showButtonText]="true" [showButton]="false" [buttonText]="''" commandText="Yes"
  title="Reopen Application" (accepted)="setApplicationBackToInProgress(true)" btnColor="success" class="mx-2"
  [closeOnAccept]="false">
  Are you sure you want to set this Completed application back to In Progress?
</wm-modal-confirm>

  <!-- added by furkan 07-04-2026  -->
<wm-common-confirmation-modal
  [data]="reOpenApplicationModalData"
  (onYesClick)="handleReOpenApplicationModalAccepted()"
  (onNoClick)="handleReOpenApplicationModalRejected()">
</wm-common-confirmation-modal>
  <!-- ended by furkan 07-04-2026  -->
